/** Source: public/design-patterns.html F-3a. */
export function Company({ rows = [] }: { rows?: Array<[string, string]> }) {
  return <div className="shell sec tight"><table className="spec" style={{ maxWidth: 760 }}><tbody>{rows.map(([key, value]) => <tr key={key}><th>{key}</th><td>{value}</td></tr>)}</tbody></table></div>
}

